 <template>
    <Toast />
</template>

<script>
export default {
    name: 'InicioProveedores',
    data() {
        return {}
    },
    mounted() {},
    unmounted() {},
    methods: {},
}
</script>

<style lang="scss" scoped>
</style>
